import { Injectable } from '@angular/core';
import { SocketMiddlewareService } from './socket-middleware.service';
import { EapEvents } from 'icreate/common/io-event/websocket-message';

@Injectable({
    providedIn: 'root',
})
export class EapSocketService {
    constructor(private socketService: SocketMiddlewareService) {}

    eapCreated$() {
        return this.socketService.receiveMessageObserver(EapEvents.EAP_CREATED);
    }

    eapUpdated$() {
        return this.socketService.receiveMessageObserver(EapEvents.EAP_UPDATED);
    }

    eapTableUpdated$() {
        return this.socketService.receiveMessageObserver(EapEvents.EAP_TABLE_UPDATED);
    }

    ledPatternCreated$() {
        return this.socketService.receiveMessageObserver(EapEvents.LED_PATTERN_CREATED);
    }

    ledPatternUpdated$() {
        return this.socketService.receiveMessageObserver(EapEvents.LED_PATTERN_UPDATED);
    }

    ledPatternDeleted$() {
        return this.socketService.receiveMessageObserver(EapEvents.LED_PATTERN_DELETED);
    }
}
